var _path, _path2, _g, _path3, _g2, _path4, _path5, _g3, _path6, _path7, _g4, _path8, _path9, _g5, _path10, _path11, _g6, _path12, _path13, _g7, _path14, _path15, _g8, _path16, _path17, _g9, _path18, _path19, _g10, _path20, _path21, _g11, _path22, _path23, _g12, _path24, _g13, _path25, _g14, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSmallInterswitch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 156,
    height: 44,
    viewBox: "0 0 156 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_82_7241)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M51.3066 22.9498L51.8306 19.9664C51.8306 19.9664 47.7954 18.6559 44.5112 21.0864V33.021H47.9988V23.3246C49.3885 22.2047 51.3066 22.9498 51.3066 22.9498Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 19,
    width: 8,
    height: 15
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.511 21.0864C46.0911 19.9173 47.8453 19.6137 49.2401 19.614C50.7442 19.614 51.8306 19.9667 51.8306 19.9667L51.3064 22.9501C51.3064 22.9501 49.3883 22.205 47.9985 23.3246V33.021H44.511V21.0864Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0107L323.348 70.0107L323.348 -625.764H-167.787L-167.787 70.0107Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 44,
    y: 19,
    width: 8,
    height: 15
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M44.511 21.0864C46.0911 19.9173 47.845 19.614 49.2401 19.614C50.7442 19.614 51.8306 19.9667 51.8306 19.9667L51.3064 22.9501C51.3064 22.9501 49.3883 22.205 47.9985 23.3246V33.021H44.511V21.0864Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38.6643 38.8682H57.6775V13.7672H38.6643V38.8682Z",
    fill: "#58595B"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2395 16.564L24.7254 15.9073V19.7888H28.1749V22.8928H24.7254V27.5219C24.7254 28.3105 24.853 28.9365 25.1137 29.3995C25.3715 29.8695 25.8884 30.1024 26.6647 30.1024C27.0443 30.1024 27.4255 30.066 27.8277 29.9888C28.2185 29.9103 28.5828 29.8094 28.9107 29.6773L29.4039 32.5848C28.982 32.7659 28.5156 32.923 28.0014 33.0562C27.4856 33.1881 26.8523 33.2568 26.1041 33.2568C25.1529 33.2568 24.3668 33.1182 23.7417 32.8431C23.1198 32.568 22.6197 32.182 22.2469 31.6894C21.8742 31.2012 21.612 30.6021 21.4649 29.9005C21.3151 29.2002 21.2395 28.4269 21.2395 27.5738V16.564Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 21,
    y: 15,
    width: 9,
    height: 19
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.2397 16.564L24.7257 15.9073V19.7888H28.1752V22.8928H24.7257V27.5219C24.7257 28.3108 24.8532 28.9365 25.1137 29.3995C25.3715 29.8697 25.8884 30.1024 26.6647 30.1024C27.0443 30.1024 27.4253 30.066 27.8277 29.9888C28.2185 29.9103 28.583 29.8094 28.9109 29.6775L29.404 32.5848C28.9822 32.7661 28.5156 32.9232 28.0014 33.0564C27.4856 33.1883 26.8524 33.2568 26.1041 33.2568C25.1527 33.2568 24.3668 33.1182 23.7419 32.8431C23.1198 32.568 22.6195 32.182 22.2469 31.6897C21.8742 31.2012 21.6123 30.6021 21.4652 29.9005C21.3151 29.2002 21.2397 28.4271 21.2397 27.5738V16.564Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0107L323.348 70.0107L323.348 -625.764H-167.787L-167.787 70.0107Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.3928 39.1035H35.2508V10.06H15.3928L15.3928 39.1035Z",
    fill: "#58595B"
  }))), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M56.9938 30.3483C57.6314 30.3483 58.0825 30.2779 58.3503 30.1461C58.6163 30.0128 58.7452 29.7519 58.7452 29.3702C58.7452 29.0685 58.5771 28.8061 58.2323 28.583C57.8878 28.3557 57.3693 28.1032 56.6661 27.8154C56.1209 27.5979 55.6249 27.3736 55.1779 27.142C54.7366 26.9063 54.3583 26.6312 54.0459 26.3042C53.7346 25.9788 53.4937 25.5885 53.3199 25.1339C53.1462 24.6876 53.0638 24.1474 53.0638 23.5103C53.0638 22.2767 53.4937 21.2987 54.3499 20.5816C55.2073 19.8674 56.3817 19.5026 57.8807 19.5026C58.6304 19.5026 59.3477 19.5741 60.0343 19.7187C60.7195 19.859 61.2674 20.0191 61.6693 20.1803L61.0627 23.0849C60.6564 22.9348 60.2151 22.803 59.7401 22.688C59.265 22.5702 58.7299 22.5083 58.1385 22.5083C57.0471 22.5083 56.5005 22.8367 56.5005 23.4864C56.5005 23.6364 56.5244 23.7699 56.572 23.8863C56.6196 24.0042 56.7123 24.1165 56.8496 24.2244C56.9938 24.3312 57.1816 24.4517 57.4253 24.5753C57.6676 24.7058 57.9759 24.8404 58.3503 24.9934C59.1109 25.2965 59.7428 25.5912 60.2418 25.8888C60.7418 26.1862 61.1342 26.4993 61.4243 26.8471C61.7128 27.1868 61.9175 27.563 62.0323 27.9809C62.1473 28.3979 62.2074 28.879 62.2074 29.4278C62.2074 30.7286 61.7506 31.7121 60.8413 32.3773C59.9277 33.0397 58.6359 33.3735 56.9671 33.3735C55.877 33.3735 54.9691 33.2768 54.2447 33.0734C53.5176 32.8755 53.016 32.7045 52.7358 32.5724L53.3199 29.5442C53.91 29.794 54.5237 29.9876 55.1431 30.1338C55.7707 30.2768 56.3817 30.3483 56.9938 30.3483Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 52,
    y: 19,
    width: 11,
    height: 15
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M54.3499 20.5818C55.2075 19.8674 56.3817 19.5026 57.8807 19.5026C58.6306 19.5026 59.3479 19.5741 60.0345 19.7187C60.7195 19.859 61.2674 20.0189 61.6695 20.1803L61.0629 23.0849C60.6564 22.9348 60.2153 22.803 59.7401 22.688C59.2653 22.57 58.7299 22.5086 58.1387 22.5086C57.0471 22.5086 56.5008 22.8365 56.5008 23.4864C56.5008 23.6365 56.5244 23.7699 56.572 23.8863C56.6198 24.0042 56.7125 24.1165 56.8499 24.2244C56.9938 24.3312 57.1819 24.4517 57.4255 24.5753C57.6678 24.7056 57.9759 24.8406 58.3503 24.9934C59.1111 25.2965 59.743 25.5912 60.2418 25.8888C60.742 26.1862 61.1344 26.4991 61.4245 26.8471C61.7131 27.1868 61.9175 27.5628 62.0325 27.9809C62.1475 28.3979 62.2074 28.879 62.2074 29.4278C62.2074 30.7286 61.7506 31.7123 60.8416 32.3773C59.9279 33.0397 58.6361 33.3735 56.9673 33.3735C55.8772 33.3735 54.9693 33.2768 54.245 33.0734C53.5176 32.8755 53.0162 32.7045 52.7358 32.5724L53.3202 29.5442C53.9102 29.7942 54.5237 29.9876 55.1431 30.1338C55.7707 30.2766 56.3817 30.3483 56.9938 30.3483C57.6314 30.3483 58.0827 30.2781 58.3503 30.1461C58.6165 30.0128 58.7454 29.7519 58.7454 29.3702C58.7454 29.0685 58.5773 28.8061 58.2326 28.583C57.8878 28.3557 57.3693 28.1032 56.6661 27.8154C56.1209 27.5979 55.6252 27.3736 55.1779 27.142C54.7368 26.9063 54.3583 26.6312 54.0462 26.3042C53.7349 25.9785 53.4939 25.5885 53.3202 25.1339C53.1464 24.6874 53.0638 24.1474 53.0638 23.5103C53.0638 22.2769 53.4939 21.2989 54.3499 20.5818Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0107L323.348 70.0107L323.348 -625.764H-167.787L-167.787 70.0107Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M46.8892 39.2207H68.0547V13.6559H46.8892V39.2207Z",
    fill: "#58595B"
  }))), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.9516 25.4628C72.6392 26.7314 72.3099 27.9943 71.9583 29.2431C71.6078 30.4963 71.2351 31.7565 70.85 33.0249H68.136C67.8543 32.3233 67.5476 31.4898 67.2196 30.5229C66.8888 29.5519 66.5513 28.498 66.1967 27.3517C65.8463 26.2092 65.4879 24.9998 65.1205 23.72C64.7521 22.4459 64.3948 21.1577 64.053 19.854H67.7268C67.8486 20.4531 67.9873 21.1115 68.1371 21.8199C68.2859 22.5299 68.4428 23.2611 68.6067 24.0133C68.7707 24.7627 68.9458 25.516 69.125 26.2766C69.3058 27.0372 69.4909 27.7655 69.6783 28.4659C69.8817 27.732 70.0807 26.9826 70.2754 26.2149C70.4674 25.4461 70.6566 24.691 70.8372 23.9489C71.0153 23.2079 71.1904 22.488 71.35 21.7949C71.5126 21.1028 71.657 20.4531 71.7845 19.854H74.3079C74.4368 20.4531 74.5725 21.1028 74.7308 21.7949C74.885 22.488 75.0491 23.2079 75.2229 23.9489C75.391 24.691 75.5745 25.4461 75.758 26.2149C75.9471 26.9826 76.1406 27.732 76.341 28.4659C76.53 27.7655 76.7179 27.0372 76.9069 26.2766C77.0961 25.516 77.274 24.7627 77.4366 24.0133C77.5992 23.2611 77.7561 22.5299 77.9075 21.8199C78.0573 21.1115 78.1933 20.4531 78.3178 19.854H81.9441C81.5995 21.1577 81.245 22.4459 80.8765 23.72C80.5051 24.9998 80.1505 26.2092 79.7962 27.3517C79.4471 28.498 79.1026 29.5519 78.7676 30.5229C78.4301 31.4898 78.1188 32.3233 77.8417 33.0249H75.1277C74.7351 31.7565 74.3541 30.4963 73.9786 29.2431C73.6045 27.9943 73.2654 26.7314 72.9516 25.4628Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 64,
    y: 19,
    width: 18,
    height: 15
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M78.3178 19.854H81.9441C81.5995 21.1577 81.245 22.4459 80.8763 23.7198C80.5051 24.9998 80.1505 26.2094 79.796 27.3517C79.4471 28.498 79.1026 29.5519 78.7674 30.5229C78.4299 31.4898 78.1188 32.3231 77.8415 33.0249H75.1275C74.7351 31.7565 74.3541 30.4961 73.9786 29.2429C73.6045 27.9943 73.2654 26.7314 72.9516 25.4628C72.6389 26.7314 72.3097 27.9943 71.9583 29.2429C71.6078 30.4961 71.2351 31.7565 70.8498 33.0249H68.1358C67.8541 32.3231 67.5474 31.4898 67.2194 30.5229C66.8888 29.5519 66.5511 28.498 66.1967 27.3517C65.8463 26.2094 65.4876 24.9998 65.1205 23.7198C64.7521 22.4459 64.3948 21.1577 64.053 19.854H67.7266C67.8486 20.4531 67.9873 21.1112 68.1371 21.8199C68.2859 22.5299 68.4425 23.2611 68.6067 24.0131C68.7704 24.7625 68.9458 25.516 69.125 26.2766C69.3058 27.0372 69.4909 27.7655 69.6783 28.4659C69.8815 27.732 70.0805 26.9823 70.2752 26.2149C70.4672 25.4461 70.6566 24.691 70.8372 23.9489C71.0151 23.2076 71.1902 22.4878 71.35 21.7949C71.5126 21.1028 71.657 20.4531 71.7843 19.854H74.3079C74.4366 20.4531 74.5725 21.1028 74.7308 21.7949C74.885 22.4878 75.0491 23.2076 75.2227 23.9489C75.391 24.691 75.5743 25.4461 75.758 26.2149C75.9471 26.9823 76.1406 27.732 76.3408 28.4659C76.53 27.7655 76.7177 27.0372 76.9069 26.2766C77.0961 25.516 77.274 24.7625 77.4366 24.0131C77.5992 23.2611 77.7561 22.5299 77.9073 21.8199C78.0573 21.1112 78.1933 20.4531 78.3178 19.854Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0103L323.348 70.0103L323.348 -625.765H-167.787L-167.787 70.0103Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M58.2063 38.8721H87.7911V14.0074L58.2063 14.0074V38.8721Z",
    fill: "#58595B"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.4082 33.02H87.8887V19.8519H84.4082V33.02Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 84,
    y: 19,
    width: 4,
    height: 15
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M84.4082 33.02V19.8519H87.8889V33.02H84.4082Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0103L323.349 70.0103L323.349 -625.765H-167.787L-167.787 70.0103Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M78.5615 38.8667H93.7357V14.0047H78.5615V38.8667Z",
    fill: "#58595B"
  }))), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M90.6572 16.5677L94.1404 15.9069V19.8583H97.5874V22.9566H94.1404V27.5903C94.1404 28.3746 94.2693 29.0062 94.5257 29.4678C94.7822 29.9351 95.3018 30.1695 96.0797 30.1695C96.4566 30.1695 96.8433 30.1357 97.2383 30.0586C97.6375 29.9827 97.9992 29.8748 98.3284 29.7443L98.8176 32.6491C98.3956 32.834 97.9263 32.9914 97.4151 33.1259C96.8977 33.2578 96.2717 33.3252 95.5204 33.3252C94.5679 33.3252 93.7818 33.1879 93.1583 32.9098C92.5334 32.6391 92.0345 32.2561 91.6619 31.7592C91.2891 31.2709 91.0287 30.6689 90.8788 29.9716C90.7274 29.2686 90.6572 28.4912 90.6572 27.642V16.5677Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 90,
    y: 15,
    width: 9,
    height: 19
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M90.6572 16.5677L94.1402 15.9069V19.8583H97.5872V22.9566H94.1402V27.5903C94.1402 28.3746 94.2693 29.006 94.5257 29.4678C94.7822 29.9351 95.3018 30.1692 96.0795 30.1692C96.4564 30.1692 96.8433 30.1357 97.2383 30.0586C97.6375 29.9825 97.9992 29.8748 98.3282 29.7443L98.8174 32.6489C98.3956 32.834 97.9261 32.9914 97.4151 33.1259C96.8977 33.2578 96.2717 33.3252 95.5204 33.3252C94.5679 33.3252 93.7816 33.1879 93.1583 32.9098C92.5332 32.6388 92.0345 32.2561 91.6619 31.7594C91.2891 31.2709 91.0287 30.6691 90.8786 29.9716C90.7274 29.2686 90.6572 28.4909 90.6572 27.6422V16.5677Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0103L323.348 70.0103L323.348 -625.765H-167.787L-167.787 70.0103Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M84.8105 39.1724H104.665V10.0601H84.8105V39.1724Z",
    fill: "#58595B"
  }))), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M100.049 26.4431C100.049 25.4901 100.193 24.5922 100.482 23.7503C100.77 22.9054 101.187 22.1731 101.732 21.5457C102.278 20.9186 102.939 20.4244 103.721 20.0555C104.499 19.6921 105.387 19.504 106.385 19.504C107.039 19.504 107.64 19.57 108.186 19.6934C108.733 19.8212 109.266 19.9995 109.777 20.2309L109.054 23.2101C108.725 23.078 108.367 22.963 107.975 22.8592C107.585 22.7608 107.147 22.7091 106.665 22.7091C105.637 22.7091 104.867 23.0528 104.364 23.7375C103.853 24.4239 103.603 25.3234 103.603 26.4431C103.603 27.6258 103.84 28.5449 104.319 29.1962C104.79 29.8459 105.623 30.1729 106.806 30.1729C107.228 30.1729 107.678 30.1292 108.164 30.0465C108.646 29.9623 109.09 29.8304 109.499 29.6453L109.987 32.7015C109.581 32.8853 109.076 33.0397 108.468 33.1756C107.857 33.3079 107.189 33.3765 106.458 33.3765C105.335 33.3765 104.366 33.1941 103.557 32.8361C102.748 32.4784 102.079 31.9899 101.558 31.3725C101.032 30.7538 100.654 30.0242 100.412 29.1821C100.169 28.3388 100.049 27.4241 100.049 26.4431Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 100,
    y: 19,
    width: 10,
    height: 15
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M103.721 20.0555C104.499 19.6921 105.387 19.504 106.385 19.504C107.039 19.504 107.64 19.5698 108.186 19.6932C108.733 19.8212 109.266 19.9993 109.777 20.2309L109.054 23.2099C108.724 23.078 108.367 22.963 107.975 22.8592C107.585 22.7606 107.147 22.7089 106.665 22.7089C105.637 22.7089 104.867 23.0528 104.364 23.7375C103.853 24.4236 103.603 25.3231 103.603 26.4431C103.603 27.6258 103.84 28.5449 104.319 29.1962C104.79 29.8459 105.622 30.1729 106.806 30.1729C107.228 30.1729 107.678 30.1292 108.164 30.0465C108.646 29.9623 109.09 29.8304 109.499 29.645L109.987 32.7015C109.581 32.8853 109.076 33.0394 108.468 33.1756C107.857 33.3077 107.189 33.3765 106.458 33.3765C105.335 33.3765 104.366 33.1938 103.557 32.8359C102.748 32.4781 102.079 31.9899 101.557 31.3728C101.033 30.7538 100.654 30.0242 100.412 29.1821C100.169 28.3388 100.049 27.4239 100.049 26.4431C100.049 25.4901 100.193 24.5921 100.482 23.7503C100.77 22.9054 101.187 22.1729 101.731 21.5455C102.278 20.9183 102.939 20.4244 103.721 20.0555Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0107L323.348 70.0107L323.348 -625.764H-167.787L-167.787 70.0107Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.2019 39.2236H115.834V13.6572H94.2019V39.2236Z",
    fill: "#58595B"
  }))), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M112.239 33.0205V16.5631L115.724 15.908V19.9072C115.956 19.8243 116.255 19.7444 116.625 19.6688C116.989 19.5943 117.346 19.5549 117.688 19.5549C118.684 19.5549 119.512 19.7023 120.176 19.9928C120.838 20.2848 121.372 20.6988 121.767 21.2332C122.167 21.7652 122.445 22.4021 122.612 23.1333C122.773 23.8698 122.854 24.6896 122.854 25.5904V33.0205H119.371V26.0379C119.371 24.8367 119.226 23.9864 118.939 23.4827C118.65 22.9871 118.115 22.7362 117.338 22.7362C117.021 22.7362 116.732 22.7658 116.458 22.8218C116.186 22.8808 115.941 22.9452 115.724 23.0113V33.0205H112.239Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask8_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 112,
    y: 15,
    width: 11,
    height: 19
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M112.239 16.5631L115.723 15.908V19.9075C115.956 19.8243 116.255 19.7444 116.625 19.6688C116.989 19.5943 117.346 19.5552 117.688 19.5552C118.684 19.5552 119.512 19.7025 120.176 19.9928C120.838 20.285 121.372 20.6988 121.767 21.2335C122.167 21.7652 122.445 22.4021 122.612 23.1336C122.773 23.87 122.854 24.6896 122.854 25.5907V33.0205H119.371V26.0379C119.371 24.8369 119.226 23.9864 118.939 23.4827C118.65 22.9874 118.115 22.7362 117.338 22.7362C117.021 22.7362 116.732 22.7658 116.458 22.822C116.186 22.8808 115.941 22.9452 115.723 23.0113V33.0205H112.239V16.5631Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0107L323.348 70.0107L323.348 -625.764H-167.787L-167.787 70.0107Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M106.392 38.8677H128.701V10.0611H106.392V38.8677Z",
    fill: "#58595B"
  }))), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.18237 33.0244L7.18237 21.0912C7.18237 21.0912 8.93376 19.5939 12.7645 19.5939C16.2504 19.5939 18.1646 21.4589 18.1646 25.5634V33.0244H14.6828V25.5634C14.6828 22.9491 13.4609 22.7681 12.417 22.7681C11.3731 22.7681 10.674 23.3237 10.674 23.3237V33.0244H7.18237Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 7,
    y: 19,
    width: 12,
    height: 15
  }, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M7.18237 21.0912C7.18237 21.0912 8.93376 19.5939 12.7645 19.5939C16.2504 19.5939 18.1644 21.4587 18.1644 25.5636V33.0244H14.6828V25.5636C14.6828 22.9489 13.4609 22.7681 12.417 22.7681C11.3731 22.7681 10.674 23.324 10.674 23.324V33.0244H7.18237L7.18237 21.0912Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0103L323.348 70.0103L323.348 -625.765H-167.787L-167.787 70.0103Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.33545 38.8716H24.011V13.7474H1.33545L1.33545 38.8716Z",
    fill: "#58595B"
  }))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.62207 33.0249L0.62207 16.5647L4.10804 15.9079L4.10804 33.0249H0.62207Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask10_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 15,
    width: 5,
    height: 19
  }, _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M0.62207 16.5649L4.10804 15.9079L4.10804 33.0249H0.62207L0.62207 16.5649Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0107L323.348 70.0107L323.348 -625.764H-167.787L-167.787 70.0107Z",
    fill: "#58595B"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-5.22485 38.8716H9.95498L9.95498 10.0609H-5.22485L-5.22485 38.8716Z",
    fill: "#58595B"
  }))), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.7855 27.3855H33.9446C33.9446 27.3855 34.1197 30.1822 37.6016 30.1822C39.3448 30.1822 41.0878 29.625 41.0878 29.625L41.4366 32.6124C41.4366 32.6124 39.695 33.3521 37.257 33.3521C33.7695 33.3521 30.6338 31.4898 30.6338 26.2686C30.6338 22.1626 33.0718 19.5554 36.5566 19.5554C41.7855 19.5554 42.1357 25.143 41.7855 27.3855ZM36.3856 22.1626C34.1197 22.1626 33.9446 24.7725 33.9446 24.7725H38.8206C38.8206 24.7725 38.6498 22.1626 36.3856 22.1626Z",
    fill: "#58595B"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 30,
    y: 19,
    width: 12,
    height: 15
  }, _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6338 26.2688C30.6338 22.1628 33.0718 19.5556 36.5564 19.5556C41.7853 19.5556 42.1355 25.1434 41.7853 27.3858H33.9446C33.9446 27.3858 34.1197 30.1824 37.6014 30.1824C39.3446 30.1824 41.0875 29.6252 41.0875 29.6252L41.4364 32.6127C41.4364 32.6127 39.6948 33.3525 37.2568 33.3525C33.7695 33.3525 30.6338 31.4902 30.6338 26.2688ZM36.3853 22.1628C34.1197 22.1628 33.9446 24.7729 33.9446 24.7729H38.8206C38.8206 24.7729 38.6496 22.1628 36.3853 22.1628Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M-167.787 70.0107L323.348 70.0107L323.348 -625.764H-167.787L-167.787 70.0107Z",
    fill: "#58595B"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask12_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 127,
    y: 13,
    width: 24,
    height: 30
  }, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M127.471 15.9112C127.471 15.1155 137.493 13.3985 144.215 13.3985C147.129 13.3985 149.423 13.7214 150.01 14.5822C153.036 18.5787 131.731 43.6518 129.956 42.8913C128.532 42.5109 141.315 26.5518 139.184 20.0901C138.12 16.6731 127.471 17.0532 127.471 15.9112Z",
    fill: "white"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M121.625 48.7554H156.151V7.55187H121.625V48.7554Z",
    fill: "#ADADAD"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask13_82_7241",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 145,
    y: 1,
    width: 10,
    height: 10
  }, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M145.573 6.0329C145.573 3.30368 147.64 1.09502 150.187 1.09502C152.737 1.09502 154.801 3.30368 154.801 6.0329C154.801 8.76351 152.737 10.9722 150.187 10.9722C147.64 10.9722 145.573 8.76351 145.573 6.0329Z",
    fill: "white"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_82_7241)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M139.727 16.8193H160.648V-4.75192H139.727V16.8193Z",
    fill: "#ADADAD"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_82_7241"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 154.694,
    height: 42.3757,
    fill: "white",
    transform: "translate(0.335205 0.813477)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallInterswitch);
export default __webpack_public_path__ + "static/media/smallInterswitch.e68a03e86dc88bfffb6a799177f99a17.svg";
export { ForwardRef as ReactComponent };